var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManifold = function SvgManifold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 490 490"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M413.758 170H360v-35h-30v35h-40v-43.758L302.707 50H187.293L200 126.242V170h-40v-35h-30v35H76.242L0 157.293v115.414L76.242 260H90v60h10v120h90V320h10v-60h90v60h10v120h90V320h10v-60h13.758L490 272.707V157.293zM60 232.293l-30 5v-44.586l30 5zM267.293 80l-5 30h-34.586l-5-30zM160 410h-30v-90h30zm10-120h-50v-30h50zm190 120h-30v-90h30zm10-120h-50v-30h50zm30-60H90v-30h140v-60h30v60h140zm60 7.293-30-5v-34.586l30-5z"
  })));
};
export default SvgManifold;